module.exports = __webpack_public_path__ + "img/bgLogin.e1f53052.png";